"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Inner = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  gap: theme.spacing(3),
  textAlign: 'center'
}));
const Inner = exports.Inner = (0, _mui.styled)(Root)(({
  theme
}) => ({
  gap: theme.spacing(6),
  '&:empty': {
    display: 'none'
  }
}));
